<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <!-- <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.disbursement.date') }}</label>
          <base-select v-model="selectedRange" :options="dateRange" :allow-empty="false" :show-labels="false"
            @input="onChangeDateRange" />
          <span v-if="$v.range.$error && !$v.range.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div> -->
      <div class="row">
        <div class="col-md-8">
          <label class="report-label">{{ $t('reports.invoices.date_range') }}</label>
          <base-select
            v-model="selectedRange"
            :options="dateRange"
            :allow-empty="false"
            :show-labels="false"
            @input="onChangeDateRange"
          />
          <span v-if="$v.range.$error && !$v.range.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.from_date') }}</label>
          <base-date-picker
            v-model="formData.due_from_date"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.due_from_date.$touch()"
            @input="setRangeToCustom"
          />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.to_date') }}</label>
          <base-date-picker
            v-model="formData.due_to_date"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.due_to_date.$touch()"
            @input="setRangeToCustom"
          />
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.suppliers') }}</label>
          <base-select v-model="formData.company_id" :options="users" :group-select="false" :searchable="true"
            :show-labels="false" :placeholder="$t('suppliers.select_a_supplier')" group-values="options" group-label="label"
            track-by="id" label="name" />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{ $tc('data_exports.reports.buyers') }}</label>
          <base-select v-model="formData.buyer_company_id" :options="buyers" :group-select="false" :searchable="true"
            :show-labels="false" :placeholder="$t('clients.select_a_buyer')" group-values="options" group-label="label"
            track-by="id" label="name" />
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.status') }}</label>
          <base-select v-model="selectedStatus" :options="statuses" :allow-empty="false" :show-labels="false"
            @input="onChangeStatus" />
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.disbursement.financing_approved_date') }}</label>
          <base-date-picker v-model="formData.financing_approved_date" :calendar-button="true"
            calendar-button-icon="calendar" @change="$v.formData.financing_approved_date.$touch()" />
        </div>
      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button outline color="theme" class="report-button" @click="getReports()">
            {{ $t('reports.update_report') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style" />
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" /> <span>{{
          $t('reports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data() {
    return {
      reportTypes: ['By Customer', 'By Item'],
      selectedType: 'By Customer',
      dateRange: [
        'Today',
        'This Week',
        'This Month',
        'This Quarter',
        'This Year',
        'Previous Week',
        'Previous Month',
        'Previous Quarter',
        'Previous Year',
        'Custom'
      ],
      selectedRange: 'This Month',
      statuses: [
        'All',
        'Financed',
        'Eligible'
      ],
      selectedStatus: '',
      range: new Date(),
      formData: {
        due_from_date: moment().startOf('month').toString(),
        due_to_date: moment().endOf('month').toString(),
        status: '',
        company_id: null,
        buyer_company_id: null,
        financing_approved_date: '',
      },
      url: null,
      supplierSiteURL: null,
      newFunderArray: [],
      newClientArray: [],
      newCustomerArray: [],
      userType: null
    }
  },
  validations: {
    range: {
      required
    },
    formData: {
      // due_from_date: {
      //   required
      // },
      // financing_approved_date: {
      //   required
      // }
    }
  },
  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),
    ...mapGetters('customer', [
      'customers'
    ]),
    ...mapGetters('supplier', [
      'suppliers',
    ]),
    getReportUrl() {
      return this.url
    },

    users: {
      get: function () {
        return [
          {
            label: 'Suppliers',
            isDisable: true,
            options: this.newCustomerArray
          }
        ];
      },
      set: function (val) {
        this.formData.company_id = val
      }
    },
    buyers: {
      get: function () {
        return [
          {
            label: 'Buyers',
            isDisable: true,
            options: this.newClientArray
          }
        ];
      },
      set: function (val) {
        this.formData.buyer_company_id = val
      }
    },
  },
  watch: {
    range(newRange) {
      this.formData.due_from_date = moment(newRange).startOf('year').toString()
      this.formData.due_to_date = moment(newRange).startOf('year').toString()
      this.formData.financing_approved_date = moment(newRange).startOf('year').toString()
    },

    'formData.company_id' (value) {
      this.getReports();
    },

    'formData.buyer_company_id' (value) {
      this.getReports();
    },

  },
  created() {
    let data = { pagination: 'no' }

    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin';
      this.getSuppliers();
      this.getBuyers();
    }
  },
  mounted() {
    if (this.$route.path === '/super-admin/reports/payment-report') {
      this.$router.push('/super-admin/reports/payment-report')
    }
    this.supplierSiteURL = `/reports/payment-report/${this.getSelectedCompany.unique_hash}`
    this.getInitialReport()
  },
  methods: {
    ...mapActions('supplier', [
      'fetchSuppliers',
    ]),
    ...mapActions('customer', [
      'fetchCustomers',
      'fetchCreateCustomer'
    ]),

    async getSuppliers() {
      let res = await this.fetchSuppliers({ pagination: 'no', role: 'admin' })
      let supplierArray = res.data.suppliers.data
      // this.newCustomerArray = supplierArray.map(function (row) {
      //   return { id: row.company_id, name: row.company_name }
      // })

      var selectAll = []
      selectAll.push({ id: 'all', name: 'Select All' })

      var allSuppliers = supplierArray.map(row => {
        if (row.company_name != null) {
          selectAll.push({ id: row.company_id, name: row.company_name })
        }
      })

      this.newCustomerArray = selectAll
    },
    async getBuyers() {
      let response = await this.fetchCreateCustomer()
        if (response.data.success) {
          this.newClientArray = response.data.achorAccountType.map(function (row) {
            return { id: row.default_company_id, name: row.name }
          })
        }
    },
    getThisDate (type, time) {
      return moment()[type](time).toString()
    },
    getPreDate (type, time) {
      return moment().subtract(1, time)[type](time).toString()
    },
    onChangeDateRange () {
      switch (this.selectedRange) {
        case 'Today':
          this.formData.due_from_date = moment().toString()
          this.formData.due_to_date = moment().toString()
          break

        case 'This Week':
          this.formData.due_from_date = this.getThisDate('startOf', 'isoWeek')
          this.formData.due_to_date = this.getThisDate('endOf', 'isoWeek')
          break

        case 'This Month':
          this.formData.due_from_date = this.getThisDate('startOf', 'month')
          this.formData.due_to_date = this.getThisDate('endOf', 'month')
          break

        case 'This Quarter':
          this.formData.due_from_date = this.getThisDate('startOf', 'quarter')
          this.formData.due_to_date = this.getThisDate('endOf', 'quarter')
          break

        case 'This Year':
          this.formData.due_from_date = this.getThisDate('startOf', 'year')
          this.formData.due_to_date = this.getThisDate('endOf', 'year')
          break

        case 'Previous Week':
          this.formData.due_from_date = this.getPreDate('startOf', 'isoWeek')
          this.formData.due_to_date = this.getPreDate('endOf', 'isoWeek')
          break

        case 'Previous Month':
          this.formData.due_from_date = this.getPreDate('startOf', 'month')
          this.formData.due_to_date = this.getPreDate('endOf', 'month')
          break

        case 'Previous Quarter':
          this.formData.due_from_date = this.getPreDate('startOf', 'quarter')
          this.formData.due_to_date = this.getPreDate('endOf', 'quarter')
          break

        case 'Previous Year':
          this.formData.due_from_date = this.getPreDate('startOf', 'year')
          this.formData.due_to_date = this.getPreDate('endOf', 'year')
          break

        default:
          break
      }
    },
    onChangeStatus() {
      this.formData.status = this.selectedStatus
    },
    setRangeToCustom() {
      this.selectedRange = 'Custom'
    },
    async getInitialReport() {
      this.url = `${this.supplierSiteURL}?type=preapproved&due_from_date=${moment(this.formData.due_from_date).format('DD/MM/YYYY')}&due_to_date=${moment(this.formData.due_to_date).format('DD/MM/YYYY')}`
      return true
    },
    async viewReportsPDF() {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },
    async getReports(isDownload = false) {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      // if (this.$v.$invalid) {
      //   return true
      // }

      this.url = `${this.supplierSiteURL}?type=preapproved&due_from_date=${moment(this.formData.due_from_date).format('DD/MM/YYYY')}&due_to_date=${moment(this.formData.due_to_date).format('DD/MM/YYYY')}`

      if (this.formData.company_id && this.formData.company_id.id !== 'all') {
        this.url += `&company_id=${this.formData.company_id.id}`
      }
      if (this.formData.buyer_company_id && this.formData.buyer_company_id != null) {
        this.url += `&buyer_company_id=${this.formData.buyer_company_id.id}`
      }
      if (this.formData.status && this.formData.status != null) {
        this.url += `&request_level=${this.formData.status}`
      }
      if (this.formData.financing_approved_date && this.formData.financing_approved_date != null) {
        this.url += `&financing_approved_date=${moment(this.formData.financing_approved_date).format('DD/MM/YYYY')}`
      }

      return true
    },
    downloadReport() {
      if (!this.getReports()) {
        return false
      }

      window.open(this.getReportUrl + '&download=true')
      setTimeout(() => {
        this.url = `${this.supplierSiteURL}?type=preapproved&due_from_date=${moment(this.formData.due_from_date).format('DD/MM/YYYY')}&due_to_date=${moment(this.formData.due_to_date).format('DD/MM/YYYY')}`

        if (this.formData.company_id && this.formData.company_id.id !== 'all') {
          this.url += `&company_id=${this.formData.company_id.id}`
        }
        if (this.formData.buyer_company_id && this.formData.buyer_company_id != null) {
          this.url += `&buyer_company_id=${this.formData.buyer_company_id.id}`
        }
        if (this.formData.status && this.formData.status != null) {
          this.url += `&request_level=${this.formData.status}`
        }
        if (this.formData.financing_approved_date && this.formData.financing_approved_date != null) {
          this.url += `&financing_approved_date=${moment(this.formData.financing_approved_date).format('DD/MM/YYYY')}`
        }
        return true
      }, 200)
    },
  }
}
</script>
